import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetAllRolePermissionByRoleId,
  GetAllRolePermissions,
  LoginUser,
} from "../../Apis/loginApi";
import Loader from "../../Common/Loader/loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import ReCAPTCHA from "react-google-recaptcha";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./login.css";
import isGHMC from "../../Common/helper/helpar";

const LoginForm = ({ updateLoginPermission, setIsLoggedIn, validPaths }) => {
  const navigate = useNavigate();
  const captchaRef = useRef(null);
  // const [captcha, setCaptcha] = useState(randomString);
  const [enteredCaptcha, setEnteredCaptcha] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const isProd = isGHMC();
  // const refreshString = () => {
  //   setCaptcha(Math.random().toString(36).slice(8));
  // };

  useEffect(() => {
    document.title = isProd ? "Solid Waste Management" : "Solid Waste Management";
  }, []);

  const [credentials, setCredentials] = useState({
    emailId: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  // const handleCaptchaChange = (text) => {
  //   setCaptcha(text);
  // };

  // const handleCaptchaRefresh = () => {
  //   captchaRef.current.refresh();
  //   setInputCaptcha("");
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const handleCaptchaChange = (value) => {
    setEnteredCaptcha(value); // Store the reCAPTCHA response
  };
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  // const resetCaptcha = () => {
  //   if (captchaRef.current) {
  //     captchaRef.current.reset();
  //   }
  //   setEnteredCaptcha("");
  // };

  const resetCaptcha = () => {
    try {
      if (captchaRef.current) {
        captchaRef.current.reset();
      }
      setEnteredCaptcha("");
    } catch (error) {
      console.error("Error resetting captcha:", error);
    }
  };

  // Set Cookie Token
  const setCookie = (key, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    // Set cookie for the root domain
    document.cookie = `${key}=${
      value || ""
    }${expires}; domain=.vmaxtechservices.life; path=/;`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!credentials.emailId) {
      toast.error("Please enter your email.", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }

    if (!emailPattern.test(credentials.emailId)) {
      toast.error("The field EmailId has the incorrect Format.", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }

    if (!credentials.password) {
      toast.error("Please enter your password.", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }
    // Check if the captcha field is empty or incorrect
    // if (enteredCaptcha === '') {
    //   setCaptchaError("Please Select the Captcha.");
    //   resetCaptcha();
    //   return; // Exit the function early if captcha is incorrect
    // } else {
    //   // Reset captcha error if it was previously set
    //   setCaptchaError("");
    // }
    // Rest of your form submission logic...
    setIsLoading(true); // Set loading to true just before making the API call
    try {
      const loginData = {
        ...credentials,
        recaptchaResponse: enteredCaptcha,
      };
      const userData = await LoginUser(loginData);
      const token = userData;
      console.log(token, "TOken");

      setCookie("token", token, 7);
      const role = userData.role;
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      // Decode the token
      const decodedToken = jwtDecode(userData);
      const userName = decodedToken.name;
      localStorage.setItem("userName", userName);
      // // roleIDs
      const rolePermissions = await GetAllRolePermissionByRoleId(
        decodedToken.RoleId,
        {}
      );

      localStorage.setItem("rolePermissions", JSON.stringify(rolePermissions));
      const allPermissions = await GetAllRolePermissions();
      sessionStorage.setItem("permissionsData", JSON.stringify(allPermissions));

      const matchedPermissions = rolePermissions.map((rolePerm) => {
        const matchedPerm = allPermissions.find(
          (perm) => perm.permissionId === rolePerm.permissionId
        );
        return {
          ...rolePerm,
          permissionName: matchedPerm ? matchedPerm.permissionName : "zone",
          permissionCategoryName: matchedPerm
            ? matchedPerm.pageCategoryName
            : "",
        };
      });

      const permissionNames = matchedPermissions.map(
        (permission) => permission.permissionName
      );

      const permissionCategoryNames = matchedPermissions.map(
        (permission) => permission.permissionCategoryName
      );
      localStorage.setItem("loginPermissions", permissionNames.join(","));
      localStorage.setItem(
        "permissionCategoryNames",
        permissionCategoryNames.join(",")
      );
      updateLoginPermission(matchedPermissions);

      if (permissionNames.includes("SATs Dashboard")) {
        navigate("/sat-dashboard");
      } else if (permissionNames.includes("SCVs Dashboard")) {
        navigate("/scv-dashboard");
      } else if (permissionNames.includes("GVPs Dashboard")) {
        navigate("/gvp-dashboard");
      } else if (permissionNames.includes("TS Primary Dashboard")) {
        navigate("/primary-dashboard");
      } else if (permissionNames.includes("TS Teritary Dashboard")) {
        navigate("/teritary-dashboard");
      } else if (permissionNames.includes("GVPs Dashboard")) {
        navigate("/gvp-dashboard");
      } else if (permissionNames.includes("SATs Dashboard")) {
        navigate("/sat-dashboard");
      } else if (permissionNames.includes("SCVs Dashboard")) {
        navigate("/scv-dashboard");
      } else if (role === "admin") {
        navigate("/organization-zone");
      } else if (permissionNames.includes("Zone")) {
        navigate("/organization-zone");
      } else if (permissionNames.includes("Circle")) {
        navigate("/organization-circle");
      } else if (permissionNames.includes("Ward")) {
        navigate("/organization-ward");
      } else if (permissionNames.includes("Vehicle Type")) {
        navigate("/vehicle-type");
      } else if (permissionNames.includes("Vehicle Capacity")) {
        navigate("/vehicle-capacity");
      } else if (permissionNames.includes("Owner Type")) {
        navigate("/owner-type");
      } else if (permissionNames.includes("Vehicles")) {
        navigate("/vehicles");
      } else if (permissionNames.includes("Loading Equipments")) {
        navigate("/loading-equipment");
      } else if (permissionNames.includes("Shifts")) {
        navigate("/shifts");
      } else if (permissionNames.includes("Collection Points")) {
        navigate("/collection-points");
      } else if (permissionNames.includes("Routes")) {
        navigate("/routes");
      } else if (permissionNames.includes("TransferStation")) {
        navigate("/transferStation");
      } else if (permissionNames.includes("Containers")) {
        navigate("/Containers");
      } else if (permissionNames.includes("Deployment Locations")) {
        navigate("/deployment-locations");
      } else if (permissionNames.includes("Route Tracking")) {
        navigate("/route-tracking");
      } else if (permissionNames.includes("Roles")) {
        navigate("/roles");
      } else if (permissionNames.includes("Users")) {
        navigate("/users");
      } else if (permissionNames.includes("Secondary Deployment InCharges")) {
        navigate("/secondary-deployment-incharges");
      } else if (permissionNames.includes("SFA InCharges")) {
        navigate("/primary-deployment-charge-master");
      } else if (permissionNames.includes("TransferStation InCharge")) {
        navigate("/transferstation-incharge");
      } else if (permissionNames.includes("Traffic Marshal")) {
        navigate("/traffic-marshal");
      } else if (permissionNames.includes("SAT Detailed Report")) {
        navigate("/day_detail_report");
      } else if (permissionNames.includes("Reported SCVs at Circle")) {
        navigate("/scv_report_circle");
      } else if (permissionNames.includes("SCVs Deployed Trips to TS/SCTP")) {
        navigate("/scv-deployed-trips");
      } else if (permissionNames.includes("SCVs Overall Trips to TS/SCTP")) {
        navigate("/overall-trips-ts/sctp");
      } else if (permissionNames.includes("Trips & Tonnage Reports")) {
        navigate("/trips-tonnage-reports");
      } else if (permissionNames.includes("Hook Loader TTR Report")) {
        navigate("/hook_loader_report");
      } else if (permissionNames.includes("Container TTR Report")) {
        navigate("/container_report");
      } else if (permissionNames.includes("GVPs Report")) {
        navigate("/gvp-report");
      } else if (permissionNames.includes("GVPs Clearance Report - Date")) {
        navigate("/gvp-report-date");
      } else if (permissionNames.includes("GVPs Clearance Report")) {
        navigate("/gvp-clearance-report");
      } else if (permissionNames.includes("GVP Multiple Clearance Report")) {
        navigate("/gvp-multiple-clearence");
      } else if (permissionNames.includes("Primary Deployment Transaction Report")) {
        navigate("/primary-deployment-transaction-report");
      } else if (permissionNames.includes("Secondary Deployment Transaction Report")) {
        navigate("/secondary-deployment-transaction-report");
      } else if (permissionNames.includes("Deloyment Hookloader Report")) {
        navigate("/deployed-hookloader-report");
      } else if (permissionNames.includes("Secondary Collection Transaction")) {
        navigate("/secondary-collection-transaction");
      } else if (permissionNames.includes("Deployed Container Transaction")) {
        navigate("/deployed-container-transaction");
      } else if (permissionNames.includes("All Transfertation Transaction")) {
        navigate("/all-transferstation-transaction");
      } else if (permissionNames.includes("Container HookLoader Transaction")) {
        navigate("/container-hookloader-transaction");
      } else if (permissionNames.includes("Traffic Marshal Transaction Report")) {
        navigate("/traffic-marshal-transaction-report");
      } else if (permissionNames.includes("Tertiary Deployment")) {
        navigate("/tertiary-deployment-details");
      } else if (permissionNames.includes("Tertiary Trip")) {
        navigate("/tertiary-trip-details");
      } else if (permissionNames.includes("Geofence Summary")) {
        navigate("/geofence-summary");
      } else if (permissionNames.includes("Geofence Vehicle Report")) {
        navigate("/geofence-vehicle-reports");
      } else if (permissionNames.includes("Geofence Vehicle Summary Report")) {
        navigate("/geofence-vehicle-summary-reports");
      } else if (permissionNames.includes("Loading Equipment Report")) {
        navigate("/loading_equipment_deployment-summary-report");
      } else if (permissionNames.includes("Loading Equipment Clearance Report")) {
        navigate("/loading_equipment_clearance-report");
      } else if (permissionNames.includes("Loading Equipment Certification")) {
        navigate("/loading_equipment_certification-report");
      } else if (permissionNames.includes("Deployment Report")) {
        navigate("/deployment-report-teritary");
      } else if (permissionNames.includes("Trip Report")) {
        navigate("/trip-report-teritary");
      } else if (permissionNames.includes("Deployment Summary Report")) {
        navigate("/summary-report-teritary");
      } else if (permissionNames.includes("Contractor Wise Loading Equipment")) {
        navigate("/contractor-wise-report");
      } else {
        if (!permissionNames.includes("Zone")) {
          // const firstPermission = permissionNames[0]
          const nextPermission = findNextPermission(permissionNames)
            .toLowerCase()
            .replace(/ /g, "-");
          navigate(nextPermission);
          // navigate(firstPermission);
        } else {
          navigate("/organization-zone");
        }
        const successMessage = userData.message || "LoggedIn Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      // setSubmissionSuccess(true); // Update submission success state
    } catch (error) {
      if (error.response && error.response.data) {
        const { statusCode, message } = error.response.data;
        toast.error(message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
        });
      } else {
        toast.error("An unexpected error occurred. Please try again.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
        });
      }
    } finally {
      resetCaptcha();
      setIsLoading(false);
    }
  };

  const findNextPermission = (permissionNames) => {
    // Loop through the permissions and find the first one that exists in the valid paths
    for (const permission of permissionNames) {
      const formattedPermission = permission.toLowerCase().replace(/ /g, "-");
      if (validPaths.includes(`/${formattedPermission}`)) {
        return formattedPermission;
      }
    }
    // If no valid permission is found, return a default path
    return "/";
  };

  return (
    <div className="main container-fluid">
      <div className="page-content1 row">
        <div
          className="l-block col-md-8"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignSelf: "center",
            alignItems: "center",
          }}
        >
          <img
            src={isProd ? "/assets/media/image/ghmclogo.png" : "/assets/media/image/login_bg.jpg"}
            style={{
              width: "30%",
            }}
          />
          <h1>Solid Waste Management</h1>
        </div>
        <div className="r-block col-md-4">
          <h2>Sign in</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group row mt-2">
              <div className="col-md-12">
                <label className="col-md-12 text-left p-0"> Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder=" Enter Your Email"
                  value={credentials.emailId}
                  name="emailId"
                  onChange={handleInputChange}
                  autoFocus
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <label className="text-left p-0">Password</label>
                {/* <label className="text-right p-0" style={{ color: "#A1A1A1" }}>
                  Forgot Password?
                </label> */}
              </div>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Password"
                  name="password"
                  value={credentials.password}
                  onChange={handleInputChange}
                  // maxLength={8}
                />
                <span
                  className="password-toggle"
                  onClick={handleTogglePassword}
                >
                  <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                </span>
              </div>
            </div>

            {/* <div className="remember-me">
              <ReCAPTCHA
               ref={captchaRef}
                sitekey="6LdRn8UpAAAAADK6zJMzhFZg45cskLczUtAzxZ70"
                onChange={handleCaptchaChange}
              />
            </div>
            <div className="form-group">
             
              {captchaError && <p className="text-danger">{captchaError}</p>}
            
            </div> */}
            <div className="remember-me">
              <input type="checkbox" style={{ marginRight: "10px" }} />
              <label style={{ display: "contents" }}>Remember Me</label>
            </div>
            <button
              type="submit"
              // className="btn btn-block"
              data-sitekey="6LdRn8UpAAAAADK6zJMzhFZg45cskLczUtAzxZ70"
              // style={{ backgroundColor: "#e74c3c", color: "#fff" }}
              className={`btn btn-block ${isProd ? "btn-blue" : "btn-red"} `}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "SIGN IN"}
            </button>
          </form>
          {isLoading && <Loader />}
          {/* <p className="mt-4">Don't have an account yet? Sign up here</p> */}
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
